import { bust } from '@/utils/helpers'

const assetsLocation = 'https://storage.googleapis.com/assets-skogkartet/'
const urls = {
  fire: (location, bustit = true) => {
    const buster = bustit ? `?${bust()}` : ''
    return `${assetsLocation}forestfire/${location}_timeline.csv${buster}`
  },
  forestLoss: (location, bustit = true) => {
    const buster = bustit ? `?${bust()}1` : ''
    return `${assetsLocation}deforestation/deforestation_${location}.csv${buster}`
  },
  forestCover: (location, bustit = true) => {
    const buster = bustit ? `?${bust()}1` : ''
    return `${assetsLocation}forestcover/forestcover_${location}.csv${buster}`
  },
  rainforest: language => {
    return `https://regnskog.no/${language}`
  }
}

/**
 * Helper class to get Url's for all API calls
 * {@link http://pragmatic-backbone.com/models-collections-and-data}
 * @author  {@link http://kartoteket.as/team/bard.html Bård Røtzer}
 * @param {String} type       - the type of method to get
 * @param {Mixed}  optional   - All other parameters, just passed on
 */
export default function(type) {
  return urls[type] ? urls[type].apply(this, [].slice.call(arguments, 1)) : undefined
}
